const local = window.location.hostname.includes('localhost:3000') || window.location.hostname.includes('ngrok.io')
const demo = window.location.hostname.includes('demo')
const staging = window.location.hostname.includes('bmstage')

export const base = {
  fontPickerApiKey: 'AIzaSyBkGrjIfUhBLycKuA1oyq52QmdLu7cK2xw',
  local,
  staging,
  demo
}
